import React, { useEffect, useState } from 'react'
import { IElementProps, IExternalDataItem } from '../../../types/interfaces'
const Input = (props: IElementProps) => {
  const [savedExternalData, setSavedExternalData] = useState<IExternalDataItem | null>(null)
  const { externalData, formReadOnly } = props

  useEffect(() => {
    if (
      props.visible &&
      !formReadOnly &&
      (externalData?.timeStamp || 0) > (savedExternalData?.timeStamp || 0) &&
      externalData &&
      Object.keys(externalData.data).length
    ) {
      const externalValue = externalData.data[Object.keys(externalData.data)[0]]

      const e = {
        target: {
          value: externalValue,
        },
      } as React.ChangeEvent<HTMLInputElement>

      setTimeout(() => {
        props.handleChange(props.name, e)
      }, props.index * 10)

      setSavedExternalData(externalData)
    }
  }, [props.externalData, formReadOnly, props.visible])

  const validationErrors = props.validationErrors[props.name]

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <div className="tooltipArea">
                <i className="icon-info"></i>
                <div className="tooltip">{props.translatedTooltip}</div>
              </div>
            )}
            <label>
              {props.label}
              {!!validationErrors?.length && props.submitFired && (
                <span style={{ color: 'red' }}>- {validationErrors.join(', ')}</span>
              )}
            </label>
          </div>
          <input
            readOnly={props.formReadOnly || props.disabledInput || props.disabledInput}
            // name={props.name}
            name={`fieldnameveryunique${new Date().getTime()}`}
            key={props.name}
            type="text"
            value={props.value}
            autoComplete="none"
            list="autocompleteOff"
            onChange={(e) => props.handleChange(props.name, e)}
            className="required-highlight"
          />
        </div>
      )}
    </>
  )
}
export default Input
